// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* analytics.css */

.modal-flex-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.modal-header-style {
  padding: 2rem;
  padding-bottom: 0;
}

.modal-title-style {
  margin: 0;
  padding: 12px;
  font-weight: 700;
  font-size: 30px;
  color: #12394d;
}

.modal-close-style {
  border: none;
  background: transparent;
  margin-left: auto;
  padding: 0;
  font-size: 1.5rem;
}

.modal-close-style-ar {
  border: none;
  background: transparent;
  margin-right: auto;
  padding: 0;
  font-size: 1.5rem;
}

.line-style {
  margin-left: 5px;
  margin-top: 5px;
  margin-bottom: 0;
  height: 0px;
  max-width: 75px;
  background-color: #d9d9d9;
  border: 2px solid #555;
}

.heading-style {
  font-size: 1.2rem;
  padding-right: 1rem;
}

.active-button {
  border: 2px solid #cc0000;
  /* Replace with your actual main red color */
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  background-color: #cc0000;
  /* Replace with your actual main red color */
  color: white;
}

.inactive-button {
  border: 2px solid gray;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  background-color: white;
  color: gray;
  border-right: none;
}

.inactive-button-left {
  border: 2px solid gray;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  background-color: white;
  color: gray;
  border-left: none;
}

.graph-div-style {
  margin-bottom: 0;
  overflow-x: scroll;
  display: flex;
  justify-content: center;
}

.label-style {
  font-family: "Roboto Bold";
  color: #333;
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/analytics.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["/* analytics.css */\n\n.modal-flex-box {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.modal-header-style {\n  padding: 2rem;\n  padding-bottom: 0;\n}\n\n.modal-title-style {\n  margin: 0;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 30px;\n  color: #12394d;\n}\n\n.modal-close-style {\n  border: none;\n  background: transparent;\n  margin-left: auto;\n  padding: 0;\n  font-size: 1.5rem;\n}\n\n.modal-close-style-ar {\n  border: none;\n  background: transparent;\n  margin-right: auto;\n  padding: 0;\n  font-size: 1.5rem;\n}\n\n.line-style {\n  margin-left: 5px;\n  margin-top: 5px;\n  margin-bottom: 0;\n  height: 0px;\n  max-width: 75px;\n  background-color: #d9d9d9;\n  border: 2px solid #555;\n}\n\n.heading-style {\n  font-size: 1.2rem;\n  padding-right: 1rem;\n}\n\n.active-button {\n  border: 2px solid #cc0000;\n  /* Replace with your actual main red color */\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  background-color: #cc0000;\n  /* Replace with your actual main red color */\n  color: white;\n}\n\n.inactive-button {\n  border: 2px solid gray;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  background-color: white;\n  color: gray;\n  border-right: none;\n}\n\n.inactive-button-left {\n  border: 2px solid gray;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  background-color: white;\n  color: gray;\n  border-left: none;\n}\n\n.graph-div-style {\n  margin-bottom: 0;\n  overflow-x: scroll;\n  display: flex;\n  justify-content: center;\n}\n\n.label-style {\n  font-family: \"Roboto Bold\";\n  color: #333;\n  font-size: 1.2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
